import $ from "jquery";
import React from 'react';
import {
  Redirect
} from 'react-router-dom'
import Chip from 'material-ui-next/Chip';
import Avatar from 'material-ui-next/Avatar';
import CSSModules from 'react-css-modules';
import styles from './all.css';
import MUITable, {
  TableBody,
  TableCell,
  TableFooter,
  TablePagination,
  TableRow,
} from 'material-ui-next/Table';
import {
  TablePaginationActions,
  EnhancedTableHead
} from '../../widgets/table_utils.react.js';
import Checkbox from 'material-ui-next/Checkbox';
import {
  check_roles,
  SELLER
} from '../../utils/roles/role_checker.js';
import ConnectIcon from '../../assets/icons/connectIcon.react.js';
import DisconnectIcon from '../../assets/icons/disconnectIcon.react.js';
import Menu, {
  MenuItem
} from 'material-ui-next/Menu';
import Toolbar from 'material-ui-next/Toolbar';
import TextField from 'material-ui-next/TextField';
import Paper from 'material-ui-next/Paper';
import Tooltip from 'material-ui-next/Tooltip';
import IconButton from 'material-ui-next/IconButton';
import CloseIcon from 'material-ui-icons/Close';
import NetworkInfoIcon from '../../assets/icons/networkInfoIcon.react.js';
import SSHIcon from '../../assets/icons/sshIcon.react.js';
import DeleteIcon from '../../assets/icons/deleteDeviceIcon.react.js';
import UpdateIcon from '../../assets/icons/updateIcon.react.js';
import AliasEditIcon from '../../assets/icons/aliasEditIcon.react.js';
import DeviceInfoIcon from '../../assets/icons/deviceInfoIcon.react.js';
import configs from '../../config.json';
import auth from '../../auth/auth.react.js';

import { CopyToClipboard } from 'react-copy-to-clipboard';

const search_url = configs.server + configs.api_path + '/devices/search';

class DeviceTable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      network_menu_anchor: {},
      ssh_menu_anchor: {},
      redirect: null,
      all_data: props.data,
      data: [],
      order: 'asc',
      orderBy: 'name',
      selected: [],
      page: 0,
      new_page: 0,
      rowsPerPage: 10,
      rowCount: 0,
      enableSelect: true,
      loading: false,
      isSeller: check_roles([SELLER]),
      searchText: ''
    }

    this.on_load_data = this.on_load_data.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleClickConnect = this.handleClickConnect.bind(this)
    this.handleClickDisconnect = this.handleClickDisconnect.bind(this)
    this.handleClickDelete = this.handleClickDelete.bind(this)
    this.handleClickUpdate = this.handleClickUpdate.bind(this)
    this.refresh = this.refresh.bind(this)
    this.handleRequestSort = this.handleRequestSort.bind(this)
    this.handleSelectAllClick = this.handleSelectAllClick.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.handleClickAliasEdit = this.handleClickAliasEdit.bind(this)
    this.handleChangePage = this.handleChangePage.bind(this)
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
    this.isSelected = this.isSelected.bind(this)
    this.sortData = this.sortData.bind(this)
    this.get_column_configs = this.get_column_configs.bind(this)
    this.get_network_info = this.get_network_info.bind(this)
    this.get_ssh_info = this.get_ssh_info.bind(this)
    this.device_info = this.device_info.bind(this)

    this.handleMenuOpen = this.handleMenuOpen.bind(this)
    this.handleMenuClose = this.handleMenuClose.bind(this)

    this.handleChangeSearchText = this.handleChangeSearchText.bind(this)
    this.handlePressSearch = this.handlePressSearch.bind(this)
    this.handleClearSearch = this.handleClearSearch.bind(this)
    this.search = this.search.bind(this)

  }

  sortData(order, orderBy) {
    var self = this;
    const { all_data } = this.state;

    const data =
      order === 'desc' ?
      all_data.sort(
        (a, b) => {
          var va = a[orderBy]
          var vb = b[orderBy]
          const get_data = self.get_column_configs(true)[orderBy].data
          if (get_data) {
            va = get_data(a)
            vb = get_data(b)
          }
          return (vb < va) ? -1 : 1
        }
      ) :
      all_data.sort(
        (a, b) => {
          var va = a[orderBy]
          var vb = b[orderBy]
          const get_data = self.get_column_configs(true)[orderBy].data
          if (get_data) {
            va = get_data(a)
            vb = get_data(b)
          }
          return (va < vb) ? -1 : 1
        }
      );

    this.setState({
      order,
      orderBy,
      data,
      loading: false
    });
  }

  pagedData = () => {
    const {
      data,
      rowsPerPage,
      page,
    } = this.state;
    return data.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    )
  }

  handleRequestSort(event, property) {
    const orderBy = property;
    let order = 'desc';
    var self = this;

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    self.sortData(order, orderBy)
  }

  handleSelectAllClick(event, checked) {
    if (checked) {
      this.setState({
        selected: this.pagedData().map(n => n.id)
      });
      return;
    }
    this.setState({
      selected: []
    });
  }

  handleClick(event, id) {
    const {
      selected
    } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    this.setState({
      selected: newSelected
    })
  }

  handleChangePage(event, page) {
    this.setState({
      page: page,
      selected: [],
    });
  }

  handleChangeRowsPerPage(event) {
    const rowsPerPage = event.target.value;
    this.setState({
      rowsPerPage: rowsPerPage,
      selected: [],
    });
  }

  isSelected(id) {
    return this.state.selected.indexOf(id) !== -1
  }

  refresh(offset, rowsPerPage) {
    this.setState({
      loading: true
    }, () => {
      this.props.load_devices(
        rowsPerPage || this.state.rowsPerPage,
        offset || this.state.new_page * this.state.rowsPerPage,
        this.on_load_data
      )
    })
  }

  search() {
    this.setState({ loading: true }, () => {
      const { searchText } = this.state;
      const { state_filter } = this.props;
      const params = {
        id: searchText,
        alias: searchText,
        state: state_filter
      };

      $.get({
          dataType: 'json',
          url: search_url,
          data: auth.with_session(params , true),
          xhrFields: {
            withCredentials: true
          }
        })
        .done((data) => {
          var _err = data.err
          if (_err && _err.ec === 0) {
            // cb(data.ret)
            this.on_load_data(data.ret);
          } else if (_err && _err.ec === 403) {
            this.props.unauthorized()
          }
        })
    });
  }

  on_load_data(all_devices) {
    this.setState({
      isSeller: false,
      all_data: all_devices.devices,
      rowCount: all_devices.devices.length,
      selected: [],
      page: this.state.new_page
    }, () => {
      this.sortData(this.state.order, this.state.orderBy)
    })
  }

  componentWillMount() {
    this.refresh()
  }

  handleClickConnect(data) {
    var self = this;
    return (e) => {
      self.props.open_connect(data)
    }
  }

  handleClickDisconnect(data) {
    var self = this;
    return (e) => {
      self.props.open_disconnect(data)
    }
  }

  handleClickDelete(data) {
    var self = this;
    return (e) => {
      self.props.open_delete(data)
    }
  }

  handleClickUpdate(data) {
    var self = this;
    return (e) => {
      self.props.open_update(data)
    }
  }

  handleClickAliasEdit(data) {
    var self = this;
    return (e) => {
      self.props.open_alias(data)
    }
  }

  handleDelete(data) {
    var self = this;
    return (e) => {
      self.props.delete_client(
        data, (err) => {
          if (!err) {
            this.props.load_clients(this.on_load_data)
          }
        }
      )
    }
  }

  get_column_configs(return_dict) {
    const columnConfigs = [{
        id: 'status',
        numeric: false,
        disablePadding: false,
        label: 'Status',
        data: (raw) => {
          return raw.state
        }
      },
      {
        id: 'name',
        numeric: false,
        disablePadding: false,
        label: 'Device Name',
        data: (raw) => {
          return raw.alias
        }
      },
      {
        id: 'system',
        numeric: false,
        disablePadding: false,
        label: 'System',
        data: (raw) => {
          return raw.alias
        }
      },
      {
        id: 'platform',
        numeric: false,
        disablePadding: false,
        label: 'Platform',
        data: (raw) => {
          return raw.alias
        }
      },
      {
        id: 'resources',
        numeric: false,
        disablePadding: false,
        label: 'Details',
        disableSort: true
      },
      {
        id: 'actions',
        numeric: false,
        disablePadding: false,
        label: 'Actions',
        disableSort: true
      }
    ]

    if (return_dict) {
      return columnConfigs.reduce((obj, item) => {
        obj[item.id] = item
        return obj
      }, {})
    }

    return columnConfigs
  }

  handleMenuClose(name) {
    var self = this;
    return (e) => {
      self.setState({
        [name]: {},
      })
    }
  }

  handleMenuOpen(name, id) {
    var self = this;
    return (e) => {
      self.setState({
        [name]: {
          [id]: e.currentTarget
        },
      })
    }
  }

  handleChangeSearchText(event) {
    this.setState({ searchText: event.target.value });
  }

  handlePressSearch(event) {
    if (event.key === 'Enter') {
      this.search();
    }
  }

  handleClearSearch(event) {
    this.setState({ searchText: '' }, () => {
      this.search();
    });
  }

  get_network_info(data) {
    if (!data.localAddress || !data.remoteAddress) {
      return null
    }
    const id = data.id
    const {
      network_menu_anchor
    } = this.state
    return (
      <div key="network">
        <Tooltip title="Network" placement="top" disableTriggerFocus={true}>
          <IconButton onClick={this.handleMenuOpen("network_menu_anchor", id)}>
            <NetworkInfoIcon />
          </IconButton>
        </Tooltip>
        <Menu
          key="network-menu"
          anchorEl={network_menu_anchor[id]}
          open={Boolean(network_menu_anchor[id])}
          onClose={this.handleMenuClose("network_menu_anchor")}
          anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
        >
          <MenuItem
            key="remote"
            disabled={true}
          >
            Remote IP: {data.remoteAddress}
          </MenuItem>
          <CopyToClipboard
            text={data.localAddress}
            onCopy={this.handleMenuClose("network_menu_anchor")}>
            <MenuItem key="lan" disabled={false}>
              LAN IP: {data.localAddress}
            </MenuItem>
          </CopyToClipboard>
        </Menu>
      </div>
    )
  }

  get_ssh_info(data) {
    const all_resources = data.resources || [];
    const ssh_resources = all_resources.filter((res) => (res.rtype.startsWith(
      'ssh')))
    if (ssh_resources.length < 1) {
      return null
    }
    const id = data.id
    const {
      ssh_menu_anchor
    } = this.state
    return (
      <div key="ssh">
        <Tooltip title="SSH" placement="top" disableTriggerFocus={true}>
          <IconButton onClick={this.handleMenuOpen("ssh_menu_anchor", id)}>
            <SSHIcon />
          </IconButton>
        </Tooltip>
        <Menu
          key="ssh-menu"
          anchorEl={ssh_menu_anchor[id]}
          open={Boolean(ssh_menu_anchor[id])}
          onClose={this.handleMenuClose("ssh_menu_anchor")}
          anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
        >
          {ssh_resources.map((resource, idx) => {
             var title = ''
             var value = ''
             switch(resource.rtype) {
               case 'ssh-port':
                 title = "SSH Port"
                 value = (
                   ['ssh', '-p', resource.value,
                   data.defaultUsername + '@' + configs.domain].join(' ')
                 )
                 break
               default:
                 return null
             }
             return (
               <CopyToClipboard
                 text={value}
                 onCopy={this.handleMenuClose("ssh_menu_anchor")}
                 >
                 <MenuItem key={idx}>
                   {title + ': ' + resource.value}
                 </MenuItem>
               </CopyToClipboard>
             )
          })}
        </Menu>
      </div>
    )
  }

  device_info(data) {
    return (
      <div key="device">
        <Tooltip title="Runtime Info" placement="top" disableTriggerFocus={true}>
          <IconButton onClick={this.props.open_info(data)}>
            <DeviceInfoIcon />
          </IconButton>
        </Tooltip>
      </div>
    )
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={{pathname: this.state.redirect}} />
    }
    const columnConfigs = this.get_column_configs()
    const {
      loading,
      data,
      order,
      orderBy,
      selected,
      rowsPerPage,
      page,
      rowCount,
      enableSelect
    } = this.state;
    const pagedData = this.pagedData();
    const emptyRows = rowsPerPage - pagedData.length;
    return (
      <div>
        <Paper style={{ marginBottom: '5px' }}>
          <Toolbar style={{ minHeight: '45px' }}>
            <TextField
              style={{ width: '100%' }}
              value={this.state.searchText}
              onChange={this.handleChangeSearchText}
              onKeyPress={this.handlePressSearch}
              InputProps={{ disableUnderline: true }}
            />
            <IconButton
              aria-label="Close"
              onClick={this.handleClearSearch}
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </Paper>
        <MUITable styleName="dev-table">
          <EnhancedTableHead
            loading={loading}
            enableSelect={enableSelect}
            numSelected={selected.length}
            onRequestSort={this.handleRequestSort}
            onSelectAllClick={this.handleSelectAllClick}
            order={order}
            orderBy={orderBy}
            rowCount={pagedData.length}
            columnConfigs={columnConfigs}
          >
          </EnhancedTableHead>

          <TableBody>
            {
              pagedData.map((info) => {
                var actions = []
                const isSelected = this.isSelected(info.id);
                actions.push(
                  <Chip
                    key="conn"
                    avatar={<Avatar><ConnectIcon /></Avatar>}
                    deleteIcon={<DisconnectIcon />}
                    label="SSH"
                    styleName="dev-table-action"
                    onClick={this.handleClickConnect(info)}
                    onDelete={this.handleClickDisconnect(info)}
                  />
                )
                if (info.state === 'online') {
                  actions.push(
                    <Chip
                      key="update"
                      avatar={<Avatar><UpdateIcon /></Avatar>}
                      label="Update Package"
                      styleName="dev-table-action"
                      onClick={this.handleClickUpdate(info)}
                    />
                  )
                }
                actions.push(
                  <Chip
                    key="del"
                    avatar={<Avatar><DeleteIcon /></Avatar>}
                    label="Delete"
                    styleName="dev-table-action"
                    onClick={this.handleClickDelete(info)}
                  />
                )
                var device_info = []
                const net_info = this.get_network_info(info)
                if (net_info) {
                  device_info.push(net_info)
                }
                const ssh_info = this.get_ssh_info(info)
                if (ssh_info) {
                  device_info.push(ssh_info)
                }

                device_info.push(this.device_info(info))

                var device_name = info.alias
                if (info.alias !== info.id) {
                  device_name = (
                    <Tooltip
                      title={"ID: " + info.id}
                      placement="top"
                      disableTriggerFocus={true}>
                      <span>
                        {info.alias}
                      </span>
                    </Tooltip>
                  )
                }

                return (
                  <TableRow
                    key={info.id}
                    aria-checked={isSelected}
                    selected={isSelected}
                    >
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={isSelected}
                        onClick={(event) => {this.handleClick(event, info.id)}}
                      />
                    </TableCell>
                    <TableCell padding="dense" className={null}>{info.state}</TableCell>
                    <TableCell padding="dense"><div>
                      {device_name}
                      <Tooltip
                        title="Set Alias"
                        placement="top"
                        disableTriggerFocus={true}>
                        <IconButton
                          color="primary"
                          aria-label="Change Alias"
                          onClick={this.handleClickAliasEdit(info)}>
                          <AliasEditIcon />
                        </IconButton>
                      </Tooltip>
                    </div></TableCell>
                    <TableCell padding="dense" className={null}>{info.system}</TableCell>
                    <TableCell padding="dense" className={null}>{info.platform}</TableCell>
                    <TableCell padding="dense"><div styleName="dev-table-icon-cell">
                      {device_info}
                    </div></TableCell>
                    <TableCell>
                      <div>
                        {actions}
                      </div>
                    </TableCell>
                  </TableRow>
                )
              })
            }
            {emptyRows > 0 && (
               <TableRow>
                 <TableCell colSpan={6} />
               </TableRow>
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                count={rowCount}
                rowsPerPageOptions={[10, 25, 50]}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={this.handleChangePage}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                Actions={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </MUITable>
      </div>
    )
  }
}

DeviceTable.defaultProps = {
  data: [],
  load_devices: null,
  open_activation: null,
  open_deactivation: null,
  open_delete: null,
  open_update: null,
  open_alias: null,
  open_info: null
}

export default CSSModules(DeviceTable, styles)



// WEBPACK FOOTER //
// ./src/views/devices/device_table.react.js